import React from 'react';
import PropTypes from 'prop-types';
import { compose } from 'utils/react';
import { Icon } from 'components';
import { BUILDER } from 'shared/abilities';
import stylesGlobal from '../../../theme/facility-globals.scss';
import { section } from '../decorators';
import classes from './ChildBlock.scss';


const ChildBlock = ({ isEditable = false }) => (
  <div className={`${stylesGlobal.section} ${classes.root}`}>
    {isEditable ? (
      <div className={classes.container}>
        <Icon icon="global" />
        Page Content
      </div>
    ) : false}
  </div>
);
ChildBlock.propTypes = {
  isEditable: PropTypes.bool,
};

const component = compose(
  section({
    name: 'Page Content',
    hidden: true,
  }, {
    menu: false, // Child block cannot be deleted... it is all powerful
  }),
)(ChildBlock);

component.authorization = { action: 'manage', subject: BUILDER };

export default component;
